import { maskDate } from 'utils/mask';

export const dadosFormatados = (trackingData: any) => {
  const data = trackingData.map((elm: any) => {
    let statusFinaly = '';
    switch (elm.status) {
      case 'AE':
        statusFinaly = 'Aguardando expedição';
        break;
      case 'ET':
        statusFinaly = 'Em transito';
        break;
      case 'CC':
        statusFinaly = 'Chegada ao cliente';
        break;
      case 'EF':
        statusFinaly = 'Entrega finalizada';
        break;
      default:
        statusFinaly = '';
        break;
    }
    return {
      'Número da NF': elm.nfNumNota,
      Status: statusFinaly,
      Cliente: elm.destinatario,
      Veículo: elm.placa,
      'Data de embarque': maskDate(elm.dtSaida),
      'Cidade origem': elm.cidadeOrigem,
      'Cidade destino': elm.cidadeDestino,
      'Localização do veiculo': elm.localizacao,
      'Previsão de entrega': elm.dtPrevChegada,
    };
  });

  return data;
};
